import React, { useState } from 'react';
import OrderSummary from '../../Common/Ordersummary';

const Placeorder = () => {
  const [quantities, setQuantities] = useState([1, 1, 1]);

  const products = [
    { id: 1, name: 'Product 1', price: 100, image: 'image_url_1' },
    { id: 2, name: 'Product 2', price: 200, image: 'image_url_2' },
    { id: 3, name: 'Product 3', price: 300, image: 'image_url_3' },
  ];

  const deliveryCharges = 50;

  return (
    <div className="p-4 md:mt-60 mt-40">
      <div className="flex flex-col rounded-2xl md:flex-row gap-5 md:ml-28">
        <div className="md:w-2/3">
          <div className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="font-bold text-xl">DELIVERY ADDRESS</h1>
                <br />
                <h3 className="font-bold text-lg">Username, 1234567890</h3>
                <br />
                <p>171, Anna Mazhai Nagar, Kaladipet, Chennai, Tamil Nadu - 600 019</p>
              </div>
              <a href="/addresspage">
                <button className="bg-blue-500 text-white px-12 py-2 rounded hover:bg-blue-600">
                  Edit
                </button>
              </a>
            </div>
          </div>

          <div className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl flex justify-between items-center">
            <div>
              <a href="/AddAddress">
                <span className="px-4 py-2 rounded-full flex text-blue-500 items-center">
                  <span className="text-2xl font-bold mr-1">+ Add a new address</span>
                </span>
              </a>
            </div>
          </div>

          <div className="flex justify-end mt-5">
            <a href="/paymentoptiongoogle">
              <button className="bg-[#FF0004] text-white px-10 py-3 rounded hover:bg-red-700">
                Delivery Here
              </button>
            </a>
          </div>
        </div>

        <OrderSummary products={products} quantities={quantities} deliveryCharges={deliveryCharges} />
      </div>
    </div>
  );
};

export default Placeorder;
